/** Context فهرست فاکتورها برای قبلی/بعدی در InvoiceWorkspace */
const CTX_KEY = "gx-invoice-list-ctx";

export function saveInvoiceListCtx(ctx) {
  try {
    sessionStorage.setItem(CTX_KEY, JSON.stringify({
      ids: ctx.ids || [],
      index: ctx.index ?? 0,
      returnTo: ctx.returnTo || "/supply-chain/events",
      filters: ctx.filters || null,
      updatedAt: Date.now(),
    }));
  } catch { /* */ }
}

export function loadInvoiceListCtx() {
  try {
    const raw = sessionStorage.getItem(CTX_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearInvoiceListCtx() {
  try { sessionStorage.removeItem(CTX_KEY); } catch { /* */ }
}
